import './style.scss';

import type { JSX } from '@ionic/core';
import { IonSlides } from '@ionic/react';
import * as React from 'react';
import { useContextTranslation } from '../../translation';

interface SwiperNavigationProps {
  slider: React.RefObject<HTMLIonSlidesElement>;
}

const SwiperWithNavigation: React.FC<JSX.IonSlides & SwiperNavigationProps> = ({
  children,
  slider,
  ...rest
}) => {
  const [swiper, setSwiper] = React.useState<any>({});
  const t = useContextTranslation('misc');

  const [swiperNavigation, setSwiperNavigation] = React.useState({
    isBeginning: swiper?.isBeginning,
    isEnd: swiper?.isEnd,
  });

  const handleSlidesControlNext = () => {
    swiper?.slideNext();
  };
  const handleSlidesControlPrev = () => {
    swiper?.slidePrev();
  };

  const init = async () => {
    const getSwiper = await slider?.current?.getSwiper();
    setSwiper(getSwiper);
    setSwiperNavigation({
      isBeginning: getSwiper?.isBeginning,
      isEnd: getSwiper?.isEnd,
    });
  };

  const handleSlideChange = () => {
    setSwiperNavigation({
      isBeginning: swiper?.isBeginning,
      isEnd: swiper?.isEnd,
    });
  };

  return (
    <>
      <IonSlides
        onIonSlidesDidLoad={init}
        onIonSlideDidChange={handleSlideChange}
        ref={slider}
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...rest}
      >
        {children}
      </IonSlides>
      <button
        type="button"
        className={`swiper-button swiper-button-prev ${
          swiperNavigation.isBeginning ? '' : 'swiper-button-active'
        }`}
        onClick={handleSlidesControlPrev}
        aria-label={t('previous')}
      />
      <button
        type="button"
        className={`swiper-button swiper-button-next ${
          swiperNavigation.isEnd ? '' : 'swiper-button-active'
        }`}
        onClick={handleSlidesControlNext}
        aria-label={t('next')}
      />
    </>
  );
};

export default SwiperWithNavigation;
